import React, { Component } from "react";
import {
    ListGroup,
    ListGroupItem
} from "reactstrap";

import * as fun from '../../events'

class ButtonMenu extends Component {

    constructor(props) {
        super(props);

        this.opcion = this.props.opcion ? this.props.opcion: {};
    }

    getButtonFunction = () => {
        const fnName = this.props.opcion.cb.cb;
        const params = this.props.opcion.cb.params;
        const customFunc =  fnName && (Array.isArray(params) ? (fun)[fnName](...params) : (fun)[fnName]({ ...params }));
        customFunc(this.props)
    }

    render = () => {
        
        return (
            <ListGroup flush>
                <ListGroupItem
                    key={`list-${this.props.dataProps.idOpcion}`}
                    onClick = { ()=>
                    {
                        this.getButtonFunction()
                    }
                     }
                    tag='button'
                    className='border-light set-cursor text-left'>
                    {this.opcion.label}
                </ListGroupItem>
            </ListGroup>

        )
    }

}

export default ButtonMenu;